import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Maximize2 } from "lucide-react";

// Pin "casa" (posizione struttura) — blu con anello
const homeIcon = L.divIcon({
  className: "",
  html: `<div style="position:relative;width:30px;height:30px">
    <span style="position:absolute;inset:0;border-radius:50%;background:rgba(37,99,235,.28);animation:wb3pmp 2s ease-out infinite"></span>
    <span style="position:absolute;top:5px;left:5px;width:20px;height:20px;border-radius:50%;background:#2563EB;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.45)"></span>
  </div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});

const poiIcon = (color = "#16130F") => L.divIcon({
  className: "",
  html: `<div style="position:relative;width:28px;height:36px">
    <svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 0C6.3 0 0 6.1 0 13.6 0 23 14 36 14 36s14-13 14-22.4C28 6.1 21.7 0 14 0z" fill="${color}"/>
      <circle cx="14" cy="13.5" r="5" fill="#fff"/>
    </svg>
  </div>`,
  iconSize: [28, 36],
  iconAnchor: [14, 36],
});

function FitBounds({ pts }) {
  const map = useMap();
  useEffect(() => {
    if (!pts.length) return;
    if (pts.length === 1) {
      map.setView([pts[0].lat, pts[0].lng], 15);
    } else {
      try {
        map.fitBounds(pts.map((p) => [p.lat, p.lng]), { padding: [45, 45], maxZoom: 16 });
      } catch (_) {
        map.setView([pts[0].lat, pts[0].lng], 14);
      }
    }
    setTimeout(() => { try { map.invalidateSize(); } catch (_) {} }, 220);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}

export default function V3Map({ points, interactive = false, height = 190, radius = 18, onExpand }) {
  const pts = (points || []).filter((p) => p && isFinite(p.lat) && isFinite(p.lng));
  if (!pts.length) return null;
  return (
    <div style={{ position: "relative", width: "100%", height, borderRadius: radius, overflow: "hidden", background: "#e8e8ea" }}>
      <MapContainer
        center={[pts[0].lat, pts[0].lng]}
        zoom={14}
        zoomControl={interactive}
        dragging={interactive}
        scrollWheelZoom={interactive}
        doubleClickZoom={interactive}
        touchZoom={interactive}
        keyboard={interactive}
        attributionControl={false}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {pts.map((p, i) => (
          <Marker key={i} position={[p.lat, p.lng]} icon={p.type === "home" ? homeIcon : poiIcon(p.color)} />
        ))}
        <FitBounds pts={pts} />
      </MapContainer>
      {!interactive && onExpand && (
        <button
          onClick={onExpand}
          aria-label="Ingrandisci mappa"
          data-testid="wb3-map-expand"
          style={{ position: "absolute", inset: 0, background: "transparent", border: "none", cursor: "pointer", zIndex: 500 }}
        >
          <span style={{ position: "absolute", right: 10, bottom: 10, width: 38, height: 38, borderRadius: 12, background: "rgba(22,19,15,.82)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 12px -4px rgba(0,0,0,.5)" }}>
            <Maximize2 size={18} />
          </span>
        </button>
      )}
    </div>
  );
}
